import { useCurrentShop } from '../contexts/CurrentShopContext';

export interface UseShopScopedPageOptions {
  enabled?: boolean;
  /** When true, blocks the page if "all shops" is selected (for create/edit flows). */
  requireSingleShop?: boolean;
}

/**
 * For admin operational pages: expose whether data loading should wait for a shop selection.
 */
export function useShopScopedPage(options: UseShopScopedPageOptions = {}) {
  const { enabled = true, requireSingleShop = false } = options;
  const {
    currentShopId,
    loading: shopLoading,
    shops,
    currentShop,
    isAllShopsMode,
  } = useCurrentShop();

  const needsShopSelection =
    enabled &&
    !shopLoading &&
    ((shops.length > 1 && !currentShopId) ||
      (requireSingleShop && isAllShopsMode));

  const canLoad =
    enabled &&
    !shopLoading &&
    !needsShopSelection &&
    (shops.length === 0 || !!currentShopId);

  return {
    currentShopId,
    shopLoading,
    shops,
    currentShop,
    isAllShopsMode,
    needsShopSelection,
    canLoad,
  };
}
